// extracted by mini-css-extract-plugin
module.exports = {"BarStyle":"SearchBar_BarStyle__2PTzH","searchBox":"SearchBar_searchBox__3sh5K","icon":"SearchBar_icon__1ASF-","links":"SearchBar_links__2J7m-"};